import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import * as reducers from '.';
import { createMiddleware as createMzMiddleware } from './Mz';
import { sagas as profileModuleSagas } from './ProfileModule';
import { sagas as downloadsModuleSagas } from './DownloadsModule';
import { sagas as boughtModuleSagas } from './BoughtModule';
import { sagas as reviewsModuleSagas } from './ReviewsModule';
import { sagas as savedModuleSagas } from './SavedModule';

export default function createStoreAndRunSagas() {
  const sagaMiddleware = createSagaMiddleware();
  const mzMiddleware = createMzMiddleware(global);

  const reducer = combineReducers(reducers);
  const store = createStore(
    reducer,
    compose(
      applyMiddleware(sagaMiddleware, mzMiddleware),
      window && window.devToolsExtension ? window.devToolsExtension() : (f) => f,
    ),
  );

  const { watchLoadBalance, watchLoadCards, watchDoDeleteCard, watchAddUndoableAction } = profileModuleSagas({ store });
  const { watchGetMoreDownloads, watchSetDownloadsLicenceFilter, watchSetDownloadsKeywordFilter } = downloadsModuleSagas({ store });
  const { watchGetMoreBought, watchSetBoughtKeywordFilter } = boughtModuleSagas({ store });
  const { watchGetMoreReviews, watchSubmitReview, watchGetNumOfCommentedReviewsSaga, watchGetReviewReasonsSaga } = reviewsModuleSagas();
  const { watchGetMoreSaved, watchSetSavedKeywordFilter, watchDeleteSaved } = savedModuleSagas({ store });

  function* rootSagas() {
    yield [
      watchLoadBalance(),
      watchLoadCards(),
      watchDoDeleteCard(),
      watchGetMoreDownloads(),
      watchSetDownloadsLicenceFilter(),
      watchSetDownloadsKeywordFilter(),
      watchGetMoreBought(),
      watchSetBoughtKeywordFilter(),
      watchGetMoreSaved(),
      watchSetSavedKeywordFilter(),
      watchDeleteSaved(),
      watchAddUndoableAction(),
      watchGetMoreReviews(),
      watchSubmitReview(),
      watchGetNumOfCommentedReviewsSaga(),
      watchGetReviewReasonsSaga(),
    ];
  }

  sagaMiddleware.run(rootSagas);
  return store;
}
